<template>
  <div>
    <nav v-if="breadcrumb" class="border-b border-gray-300 py-2 px-2 mb-4 md:px-0">
      <div class="flex justify-between items-center">
        <div class="">
          <div class="hidden md:flex text-sx">
            <router-link :to="{name:'home'}">Home</router-link>
            <span class="mx-2">/</span>
            <router-link :to="{name:'customers'}">Vouchers</router-link>
          </div>
          <div class="text-xl text-primary">
            Vouchers
          </div>
        </div>
        <div class="">
          <router-link
              class="py-1 px-2 md:py-2 md:px-4 bg-teal-500 hover:bg-teal-700 md:font-semibold text-white hover:text-white  hover:border-transparent rounded float-right"
              :to="{name:'gen_vouchers'}">
            Generate Vouchers
          </router-link>
        </div>
      </div>
    </nav>
    <div class="pb-4">
      <div class="bg-white pt-3 border rounded shadow-sm">
        <div class="font-semibold mx-2 text-gray-600">{{ title }}</div>
        <div class="flex justify-between pt-2 px-3">
          <div>
            <label class="block tracking-wide text-gray-700">Records</label>
            <select v-model="recordsPerPage" @change="loadStats(currentPage)"
                    class="block appearance-none w-full bg-white border border-gray-300  px-4 py-2  rounded leading-tight focus:outline-none focus:border-gray-500">
              <option>5</option>
              <option>10</option>
              <option>25</option>
              <option>50</option>
              <option>100</option>
              <option>250</option>
            </select>
          </div>
          <div>
            <label class="block tracking-wide text-gray-700">Search</label>
            <input v-model="searchString" @change="loadStats(currentPage)"
                   class="appearance-none block w-full text-gray-700 border border-gray-300 rounded py-2 px-4 leading-tight focus:outline-none focus:border-gray-500"
                   type="text" placeholder="Search">
          </div>
        </div>
        <div class=" overflow-auto ">
          <table v-if="!loading" class="table-auto w-full">
            <thead>
            <tr class="border-b font-bold">
              <td class="px-4 py-2"></td>
              <td class="px-4 py-2">Name</td>
              <td class="px-4 py-2">value</td>
              <td class="px-4 py-2">Expiry date</td>
              <td class="px-4 py-2">Redeemed entries</td>
              <td class="px-4 py-2">Description</td>
            </tr>
            </thead>
            <tbody>
            <tr class="border-b" v-for="(voucher,index) in vouchers" :key="voucher.id">
              <td class="px-4 py-2">{{ index + 1 }}</td>
              <td class="px-4 py-2">{{ voucher.name }}</td>
              <td class="px-4 py-2">{{ voucher.face_value }}</td>
              <td class="px-4 py-2">{{ voucher.valid_till }}</td>
              <td class="px-4 py-2">{{ voucher.redeemed_entries }}</td>
              <td class="px-4 py-2">{{ voucher.description }}</td>

            </tr>
            </tbody>
          </table>

          <div v-else class="py-6 text-center w-full">
            <feather animation="spin" type="loader" size="32" class="mr-4"></feather>
            <p>Loading...</p>
          </div>
          <Pagination class="py-2 px-3" :total-count="vouchersCount" :current-page="currentPage"
                      :tag="'connections'" :offset="offset"
                      :records-count="vouchers != null ? vouchers.length || 0 : 0"
                      :click-handler="loadStats" :records-per-page="parseInt(recordsPerPage)"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GraphQl from "../../services/graphql.service";
import Pagination from "@/components/Pagination";

export default {
  name: "Vouchers",
  components: {Pagination},
  data() {
    return {
      searchString: '',
      recordsPerPage: this.rowsPerPage,
      vouchers: [],
      vouchersCount: 0,
      currentPage: 1,
      loading: true
    }
  },
  props: {
    title: {type: String, default: 'Authorized connections'},
    rowsPerPage: {type: Number, default: 10},
    breadcrumb: {default: true, type: Boolean}
  },
  mounted() {
    this.loadStats();
  },

  computed: {
    offset: function () {
      return (this.currentPage - 1) * this.recordsPerPage;
    }
  },
  watch: {
    searchString: function () {
      this.currentPage = 1;
    },
  },
  methods: {
    loadStats(newPage) {
      this.currentPage = newPage || 1;
      this.loading = true
      let params = 'limit: ' + this.recordsPerPage + ', offset: ' + this.offset + ', order: "created_at desc", search: "' + this.searchString + '"';
      GraphQl.sendRequest('{vouchers(' + params + ') {name redeemed_entries description valid_till face_value}}')
          .then(response => {
            this.vouchers = response.vouchers;
          })
          .finally(() => {
            this.loading = false;
          })
    }
  }
}
</script>

<style scoped>

</style>